import { useMemo } from 'react';
import { updateSelectedRowsFromIds } from './use-computed-selected-row-ids.business';

interface UseComputedSelectedRowIdsParams<T extends { id: string }> {
    tableData?: T[];
    selectedRows?: T[];
    selectedRowIds?: Set<string>;
    setSelectedRows?: React.Dispatch<React.SetStateAction<T[]>>;
    setSelectedRowIds?: React.Dispatch<React.SetStateAction<Set<string>>>;
}

export const useComputedSelectedRowIds = <T extends { id: string }>({
    tableData,
    selectedRows,
    selectedRowIds,
    setSelectedRows,
    setSelectedRowIds,
}: UseComputedSelectedRowIdsParams<T>) => {
    const computedSetSelectedRowIds = useMemo(() => {
        if (setSelectedRowIds) {
            return setSelectedRowIds;
        }
        if (!setSelectedRows) {
            return undefined;
        }

        return updateSelectedRowsFromIds(setSelectedRows, tableData);
    }, [setSelectedRowIds, setSelectedRows, tableData]);

    const computedSelectedRowIds = useMemo(
        () => selectedRowIds ?? new Set(selectedRows?.map((selectedRow) => selectedRow.id) ?? []),
        [selectedRows, selectedRowIds]
    );

    return { computedSelectedRowIds, computedSetSelectedRowIds };
};
